module.exports = __webpack_public_path__ + "img/icon_people.47bf729f.svg";